module.exports = __webpack_public_path__ + "media/img/scholarship_types/Community Service Scholarships-fd79f8d02f750d98a5cd649857206ca3.svg";